import React from 'react';
import { useLanguage } from '../../../Hooks/useLanguage';
import EmailSentSuccess from './EmailSentSuccess.component';
import { useNavigation, Navigate } from '../../../Hooks';
import { Route } from '../../../Constants/Routes.constants';

const goBack = (navigate: Navigate, returnUrl?: string) => () =>
  navigate(returnUrl ? returnUrl : Route.LOGIN);
export const useEmailSentSuccess = () => {
  const { t } = useLanguage();
  const { navigate, getSearchParams } = useNavigation();
  const { returnUrl } = getSearchParams();
  return {
    t,
    backToLogin: goBack(navigate, returnUrl),
  };
};

const EmailSentSuccessContainer = () => {
  const { t, backToLogin } = useEmailSentSuccess();

  return <EmailSentSuccess backToLogin={backToLogin} t={t} />;
};

export default EmailSentSuccessContainer;
